import { CommonModule } from '@angular/common';
import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Router, RouterModule } from '@angular/router';
import { combineLatest } from 'rxjs';
import { GroupFeatureAccessService } from '../../../services/group-feature-access.service';
import { GroupBillingAlert } from '../../../state/selectors/group.selector';

@Component({
  selector: 'app-group',
  standalone: true,
  imports: [RouterModule, CommonModule],
  templateUrl: './group.component.html',
  styleUrls: ['./group.component.css'],
})
export class GroupComponent implements OnInit {
  private featureAccessService = inject(GroupFeatureAccessService);
  private destroyRef = inject(DestroyRef);
  private router = inject(Router);

  readonly selectedGroup$ = this.featureAccessService.selectedGroup$;
  readonly billingAlert$ = this.featureAccessService.billingAlert$;

  bannerDismissed = false;
  currentAlert: GroupBillingAlert | null = null;
  currentGroup: any = null;

  get isAdmin(): boolean {
    return (
      this.currentGroup?.memberType?.includes?.('admin') ||
      this.currentGroup?.memberType?.includes?.('president') ||
      this.currentGroup?.memberType?.includes?.('principal')
    );
  }

  get productsLabel(): string {
    const list = this.currentAlert?.failedProducts || [];
    if (list.length === 0) return 'Subscription';
    return list
      .map((p) => {
        if (p === 'seats') return 'Member Seats';
        if (p === 'storage') return 'Storage';
        if (p === 'ai_credits') return 'AI Credits';
        return p;
      })
      .join(', ');
  }

  ngOnInit(): void {
    combineLatest([this.selectedGroup$, this.billingAlert$])
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(([group, alert]) => {
        this.currentGroup = group;
        this.currentAlert = alert;

        if (group && alert && alert.hasAlert) {
          this.featureAccessService.checkAndPromptSessionAlert(group, alert);
        }
      });
  }

  dismissBanner(): void {
    this.bannerDismissed = true;
  }

  goToBilling(): void {
    if (this.currentGroup?.id) {
      const path =
        this.currentGroup.groupType === 'church'
          ? `/groups/${this.currentGroup.id}/billing`
          : `/school/${this.currentGroup.id}/billing`;
      this.router.navigateByUrl(path);
    }
  }

  openDetails(): void {
    if (this.currentGroup && this.currentAlert) {
      this.featureAccessService.openPaymentDialog(
        this.currentGroup,
        this.currentAlert,
      );
    }
  }
}
